import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
export function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-18">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" onClick={onClick} aria-expanded={isOpen} data-id="element-19">
        <span className={`text-lg font-bold transition-colors ${isOpen ? 'text-gold' : 'text-navy group-hover:text-gold'}`} data-id="element-20">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className={`flex-shrink-0 ml-4 ${isOpen ? 'text-gold' : 'text-navy'}`} data-id="element-21">
          <ChevronDownIcon className="w-6 h-6" data-id="element-22" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-23">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-24">
            <p className="pb-6 text-gray-600 leading-relaxed" data-id="element-25">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}